import Component from '../base/component';
import {enterCodes, spaceCodes, upCodes, downCodes, homeCodes, endCodes} from '../../../mns-fe-utilities/keyCodes';
import getKeyCode from '../../../mns-fe-utilities/getKeyCode';

export default class Accordion extends Component {
    constructor(el) {
        super();
        this.itemHeaders = el.getElementsByClassName('accordion__section__header');
        this.addEventHandlers();
    }

    addEventHandlers() {
        for (let i = 0; i < this.itemHeaders.length; i++) {
            this.itemHeaders[i].addEventListener('click', e => {
                Accordion.toggleContents(e);
            });

            this.itemHeaders[i].addEventListener('keydown', e => {
                this.keyEvents(e);
            });
        }
    }

    keyEvents(e) { // eslint-disable-line complexity
        const code  = getKeyCode(e);
        const itemHeadersArray = Array.prototype.slice.call(this.itemHeaders);
        const openCodes = spaceCodes.concat(enterCodes);
        const moveCodes = upCodes.concat(downCodes);

        switch(true) {
            case openCodes.indexOf(code) > -1:
                e.preventDefault();
                Accordion.toggleContents(e);
                break;

            case moveCodes.indexOf(code) > -1: {
                e.preventDefault();
                const target = e.target;
                const index = itemHeadersArray.indexOf(target);
                const direction = downCodes.indexOf(code) > -1 ? 1 : -1;
                const length = itemHeadersArray.length;
                const newIndex = (index + length + direction) % length;
                itemHeadersArray[newIndex].focus();
                break;
            }

            case homeCodes.indexOf(code) > -1:
                e.preventDefault();
                itemHeadersArray[0].focus();
                break;

            case endCodes.indexOf(code) > -1:
                e.preventDefault();
                itemHeadersArray[itemHeadersArray.length - 1].focus();
                break;
        }
    }

    static toggleContents(e) {
        const itemHeader = e.target;
        const nextElement = itemHeader.nextElementSibling;
        itemHeader.classList.toggle('active');
        if (nextElement.className.indexOf('accordion__section__contents--open') === -1) {
            nextElement.className += ' accordion__section__contents--open';
            itemHeader.setAttribute('aria-expanded', 'true');
        } else {
            nextElement.classList.remove('accordion__section__contents--open');
            itemHeader.setAttribute('aria-expanded', 'false');
        }
        if(this.currentlyActiveSection  && this.currentlyActiveSection !== itemHeader) {
            const siblingElement = this.currentlyActiveSection.nextElementSibling;
            if (siblingElement.className.indexOf('accordion__section__contents--open') > -1) {
                this.currentlyActiveSection.classList.remove('active');
                siblingElement.classList.remove('accordion__section__contents--open');
                this.currentlyActiveSection.setAttribute('aria-expanded', 'false');
            }
        }
        this.currentlyActiveSection = e.target;
    }
}
